import styled from "@emotion/styled";

import { Info } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, Tooltip } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Text from "components/layout/Text";
import { HelpCenter } from "constants/help-center";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { withVar } from "themes/helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const StatusesNavigationHeader = () => (
  <Flex justifyContent="space-between" paddingTop="30px" paddingBottom="10px">
    <Text fontSize="13px" color="primaryColor50" textTransform="uppercase">
      Statuses
    </Text>
    <TooltipWrapper>
      <Tooltip
        placement="left"
        kind="invert"
        triggerRenderer={<Icon source={Info} size="small" customColor={withVar(DesignToken.ContentBasicSecondary)} />}
      >
        <TooltipContent>
          Statuses help you stay up to date with your tickets.
          <Button
            kind="link-inverted"
            href={HelpCenter.WHAT_ARE_STATUSES}
            target="_blank"
            onClick={() => trackEngagement("Statuses views subsection: Learn more clicked", EventPlace.Tickets)}
          >
            Learn more
          </Button>
        </TooltipContent>
      </Tooltip>
    </TooltipWrapper>
  </Flex>
);

const TooltipWrapper = styled.div`
  @media (max-width: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.mobileBreakpoint
    }) {
    display: none;
  }
`;

const TooltipContent = styled.div`
  width: 180px;
`;

export default StatusesNavigationHeader;
